export default __webpack_public_path__ + "static/media/visa.d866d371.svg";